/* eslint-disable quotes */
'use strict';
var debounce = require('lodash/debounce');
var collapsibleItem = require('../components/collapsibleItem');
var wishlistHeart = require('../product/wishlistHeart');
var urlUtils = require('../components/urlUtils');
var sortUtils = require('../components/sortUtils');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results, isCustomPriceRefinement) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    if (isCustomPriceRefinement) {
        var pmin = parseInt($(document).find('[name="inputPriceMin"]').val(), 10);
        var pmax = parseInt($(document).find('[name="inputPriceMax"]').val(), 10);
    }

    updateDom($results, '.refinements');

    if (isCustomPriceRefinement) {
        $(document).find('[name="inputPriceMin"]').val(pmin);
        $(document).find('[name="inputPriceMax"]').val(pmax);
        $(document).find('.js-price-selection-button').removeAttr('disabled');
    }
    updateClearButton();
    // Hide mobile background is no refinements are available
    var hasRefinementResults = $(document).find('.refinements').children().length > 0;

    if (!hasRefinementResults) {
        closeFilterModal();
    }

    $(document).find('.mobile-refinements').toggleClass('d-none', !hasRefinementResults).toggleClass('d-flex', hasRefinementResults);
    $(document).find(".js-noresults-reset").toggleClass('d-none', hasRefinementResults);

    // Reinit collapsible state
    var $collapsibleItems = $('.refinements').find('.collapsible-transition');

    $collapsibleItems.each(function () {
        collapsibleItem.methods.setTransitionState($(this), true);
    });
}

/**
 * Reinit updated recommendations slick sliders
 * @param {Object} $results - jQuery DOM element
 */
function reinitRecs($results) {
    updateDom($results, '.recommendations-container');

    var $sliders = $(document).find('.recommendations-container .slide-carousel');

    $sliders.each(function (index) {
        document.dispatchEvent(new CustomEvent('init.slick', {
            detail: {
                selector: $sliders[index]
            }
        }));
    });
}

/**
 * Updates the custom price refinement clear button
 */
function updateClearButton() {
    var $priceRefinement = $(document).find('.js-price-refinement');

    if (!$priceRefinement.length) {
        return;
    }

    var url = $priceRefinement.attr('data-href') || $priceRefinement.attr('href');
    var $clearButton = $(document).find('.js-price-selection-clear');

    var urlParams = new URLSearchParams(url.split('?')[1]);
    urlParams.delete('pmin');
    urlParams.delete('pmax');

    $clearButton.attr('data-href', url.split('?')[0] + '?' + urlParams.toString());
}

/**
* Parses the HTML response to extract and update specific head elements such as the page title,
* meta description, and canonical link in the current document.
*
* @param {string} response - The HTML response string to be parsed.
*
* This function utilizes the DOMParser to convert the response string into a document object,
* from which it extracts the text content of the element with the class 'wm-page-title',
* the content attribute of the meta tag with the name 'description', and the href attribute
* of the link tag with the rel 'canonical'. It then updates the current document's corresponding
* elements with these extracted values if they are present.
*/
function parseHeadElements(response) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(response, 'text/html');
    var newTitle = doc.querySelector('.wm-page-title')?.textContent;
    var newMetaDescription = doc.querySelector('meta[name="description"]')?.content;
    var newCanonicalLink = doc.querySelector('link[rel="canonical"]')?.href;
    var metas = doc.querySelectorAll('meta[name="robots"]');
    var newMetaRobots = metas.length ? metas[metas.length - 1].content : null;

    if (newTitle) {
        $('.wm-page-title').text(newTitle);
    }

    if (newMetaDescription) {
        $('meta[name="description"]').attr('content', newMetaDescription);
    }

    if (newCanonicalLink) {
        $('link[rel="canonical"]').attr('href', newCanonicalLink);
    }

    if (newMetaRobots) {
        $('meta[name="robots"]').attr('content', newMetaRobots);
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response, isCustomPriceRefinement, changeFacetMetadata) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        '.recommendations-container': reinitRecs
    };
    var elements = [];

    if (changeFacetMetadata && $(".js-is-category-search").val() === "true") {
        elements = [
            '.breadcrumb',
            '.search-page-title',
            '.grid-header',
            '.header-bar',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar',
            '.js-items-per-page',
            '.secondary-bar',
            '.js-results-count',
            '.filters-mobile-store',
            '.filters-mobile-footer',
            '.sort-order-radio-mobile',
            '.js-mobile-fiter-count-clear',
            '.js-mobile-sort-filter-buttons'
        ];
    } else {
        elements = [
            '.grid-header',
            '.header-bar',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar',
            '.js-items-per-page',
            '.secondary-bar',
            '.js-results-count',
            '.filters-mobile-store',
            '.filters-mobile-footer',
            '.sort-order-radio-mobile',
            '.js-mobile-fiter-count-clear',
            '.js-mobile-sort-filter-buttons'
        ];
    }

    // Update DOM elements that do not require special handling
    elements.forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results, isCustomPriceRefinement);
    });
}

/**
     * This function retrieves another page of content to display in the content search grid
    * @param {Event} e - the event object
    * @param {JQuery} $element - the jquery element that has the click event attached
    * @param {JQuery} $target - the jquery element that will receive the response
    * @return {undefined}
 */
function getContent(e, $element, $target) {
    e.stopPropagation();
    var url = $element.data('url');
    var isBottomPagination = $(e.currentTarget).parent().hasClass('js-bottom-pagination-content');

    e.preventDefault();

    $.spinner().start();
    $element.trigger(`search:${$target}`, e);

    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            $('.container-content-pagination').replaceWith(response);

            // Move scroll back to bottom pagination element
            if (isBottomPagination) {
                $(window).scrollTop($('.js-category-banner').offset().top);
            }
            initObserver("js-observer-tile");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
    * Get product from the server
    * @param {object} e - event object
    * @param {string} showMoreUrl - the URL to show more products
    * @param {JQuery} $target - the jquery element that will receive the response
    * @param {boolean} prevArrow - if the previous arrow was clicked
    * @return {undefined}
*/
function getProduct(e, showMoreUrl, $target, prevArrow, itemsPerPage, showLessUrl) {
    e.stopPropagation();
    var searchUpdateGridEndpoint = showMoreUrl && showMoreUrl.indexOf('UpdateGrid') !== -1;
    var data;
    var isBottomPagination = $(e.currentTarget).closest('.js-bottom-pagination').length > 0;

    if (prevArrow) {
        data = { selectedUrl: showLessUrl, prev: prevArrow };
    } else {
        if (itemsPerPage) {
            showMoreUrl = urlUtils.updateURLWithParam(showMoreUrl, "start", "0");
            data = { selectedUrl: showMoreUrl, itemsPerPage: itemsPerPage };
        } else {
            data = { selectedUrl: showMoreUrl };
        }
    }
    e.preventDefault();

    $.spinner().start();

    $(this).trigger(`search:${$target}`, e);

    var searchURL = prevArrow ? showLessUrl : showMoreUrl;

    searchURL = includeOOSSelectionToUrl(searchURL);

    $.ajax({
        url: searchURL,
        data: data,
        method: 'GET',
        success: function (response) {
            const $searchResults = searchUpdateGridEndpoint ? response : $(response);
            const productGrid = searchUpdateGridEndpoint ? response : $searchResults.find('.product-grid').html();

            $('.container-product-pagination').replaceWith(productGrid);
            updateSeoPaginationData($searchResults, searchUpdateGridEndpoint);
            updateSortOptions(productGrid);
            wishlistHeart.isInWishlist();
            // Move scroll back to bottom pagination element
            if (isBottomPagination) {
                $(window).scrollTop($('.js-category-banner').offset().top);
            }
            window.dispatchEvent(new CustomEvent("refinementUpdate"), {});

            var actualURL = window.location.href.split("?")[0];
            var newAttr = showMoreUrl.split("?")[1];

            if (prevArrow) {
                newAttr = showLessUrl.split("?")[1];
            }

            var newURL = actualURL;

            if (newAttr) {
                newURL += "?" + urlUtils.getSearchParamsWithExcludedFilters(newAttr);
            }

            var $productContainer = $(".product-detail");
            if ($productContainer.length > 0) {
                var ppcTriggerParameter = $productContainer.data("ppc-trigger-parameter");
                if (ppcTriggerParameter) {
                    var searchParams = new URLSearchParams(window.location.search);
                    var ppcValue = searchParams.get(ppcTriggerParameter);
                    if (ppcValue) {
                        newURL = newURL + "&" + ppcTriggerParameter + "=" + ppcValue;
                    }
                }
            }

            window.history.pushState({}, "", newURL);
            initObserver("js-observer-tile");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * @name updateSeoPaginationData
 * @description Update SEO pagination data from Ajax response
 * @param {String} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSeoPaginationData($response, isUpdateGridResponse) {
    const $seoContainer = isUpdateGridResponse ? $($($response)[0]) : $response.find('.js-seo-pagination-data');
    if ($seoContainer.length === 0) return;

    const $prevLink = $seoContainer.find("#js-prev");
    const $nextLink = $seoContainer.find("#js-next");
    const $canonicalLink = $seoContainer.find("#js-canonical");
    const $head = $("head");
    const $prevLinkInHead = $head.find("link[rel='prev']");
    const $nextLinkInHead = $head.find("link[rel='next']");
    const $canonicalLinkInHead = $head.find("link[rel='canonical']");

    if ($prevLinkInHead.length > 0) {
        $prevLinkInHead.remove();
    }
    if ($nextLinkInHead.length > 0) {
        $nextLinkInHead.remove();
    }
    if ($canonicalLinkInHead.length > 0) {
        $canonicalLinkInHead.remove();
    }

    let $actualURL = window.location.href;
    let $isEndParam = window.location.href.includes("&start");
    let $isStartParam = window.location.href.includes("/?start");
    let $cleanURL;

    if ($isEndParam) {
        $cleanURL = $actualURL.split("&start")[0] + "&";
    } else if ($isStartParam) {
        $cleanURL = $actualURL.split("?start")[0] + "?";
    } else {
        $cleanURL = $actualURL + ($actualURL.indexOf("?") > -1 ? "&" : "?");
    }

    if ($prevLink.attr("href") !== "null") {
        definePagination($cleanURL, $prevLink, "prev");
    }
    if ($nextLink.attr("href") !== "null") {
        definePagination($cleanURL, $nextLink, "next");
    }
    definePagination($cleanURL, $canonicalLink, "canonical");
}

/**
* Defines the pagination for the given element
* @param {string} cleanURL - the clean URL of the page
* @param {Object} element - the element containing the pagination
* @param {string} position - the position of the pagination (canonical or prev/next)
*/
function definePagination(cleanURL, element, position) {
    const $head = $("head");
    const $linkHref = element.attr("href");
    let $finalParam;

    $finalParam = $linkHref.split("start")[1] !== undefined ? "start" + $linkHref.split("start")[1] : "";

    const $cleanURL = $finalParam !== "" ? cleanURL : cleanURL.slice("?", cleanURL.length - 1);
    const $linkEl = `<link rel="${position}" href="${$cleanURL + $finalParam}"/>`;
    $head.append($linkEl);

    let $linkInHead = $head.find(`link[rel='${position}']`);
    $(`#js-${position}`).attr("href", $linkInHead.attr("href"));
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
        $('.js-mobile-sort[data-id=' + option.id + ']').attr('data-href', option.url);
    });
}

/**
 * Copies the headet store selector HTML to refinements, to prevent duplicated remote includes
 */
function mirrorHeaderStoreFilter(updateMobileName) {
    var $availabilityRefinement = $(document).find('.refinement-delivery-and-pick-up');

    if ($availabilityRefinement.length) {
        var selectedStoreName = $('.js-selected-store-id').attr('data-name');
        var $storeRefinement = $availabilityRefinement.find('.js-store-refinement .location');

        if (selectedStoreName.length > 0) {
            $storeRefinement.find('.js-selected-store').addClass('text-color-b300 bold');
            $('.js-selected-store').empty().text(selectedStoreName);
            $storeRefinement.find('.find-location-icon').addClass('d-none');
            $storeRefinement.find('.js-select-others-link').removeClass('d-none');
        }

        if (updateMobileName && selectedStoreName.length > 0) {
            $(document).find('.js-current-store').text(selectedStoreName).removeClass('text-color-t400').addClass('text-color-b300 bold');
        }
    }
}

/**
 * Selects the hidden store refinement filter to render the custom filter by store
 */
function selectHiddenStoreParams() {
    var selectedStoreID = $('.js-selected-store-id').val();
    var $applyButton = $(document).find('.js-store-refinement-link');

    if (selectedStoreID.length == 0 || $applyButton.length == 0) {
        return;
    }

    // Take base URL from hidden delivery filter
    var baseUrl = $('.js-base-url').attr('data-href').split('?')[0];

    // If pickup today filter is applied, remove it by using the remove applied filter URL
    var $pickupTodayFilterButton = $(document).find('.applied-filters-button[data-value-id=pick-up-today]');

    // If pickup today is not applied, use permalink to apply filter paramas
    var filterURL = $pickupTodayFilterButton.length ? $pickupTodayFilterButton.attr('data-href') : $(document).find('.permalink').val();
    var urlParams = new URLSearchParams(filterURL.split('?')[1]);

    // Clean uneeded URL params
    urlParams.delete("sz");
    urlParams.delete("start");
    urlParams.delete("lang");

    var storeRefinementNumber = urlUtils.getStoreRefinementNumber(urlParams);
    if (storeRefinementNumber) {
        urlParams.delete("prefn" + storeRefinementNumber);
        urlParams.delete("prefv" + storeRefinementNumber);
    }

    // Add category ID if on category page
    var $categoryIdElem = $(document).find(".category-id");

    if ($categoryIdElem.length > 0) {
        urlParams.set("cgid", $(".category-id").val());
    }

    // Populate apply button URL and trigger click
    $applyButton.attr('data-href', baseUrl + '?' + urlParams.toString()).click();
}


/**
 * Includes out-of-stock selection to the URL if selected
 *
 * @param {string} url - the original URL
 * @returns {string} the updated URL with out-of-stock selection included
 */
function includeOOSSelectionToUrl(url) {
    let excludeOOSElement = $("#refinement-exclude-oos");

    if (excludeOOSElement && excludeOOSElement.length > 0) {
        let isExcludeOOSSelected = excludeOOSElement.find("button.js-a-refinement-selected");
        if (isExcludeOOSSelected && isExcludeOOSSelected.length > 0) {
            url = urlUtils.updateURLWithParam(url, "excludeoos", true);
        }
    }

    return url;
}

/**
 * Custom handling for sorting
 *
 * @param {String} url
 * @param {Boolean} shouldUpdateSortOptions
 */
function sortResults(url, shouldUpdateSortOptions) {
    $.spinner().start();
    $(this).trigger('search:sort', url);

    url = includeOOSSelectionToUrl(url);

    $.ajax({
        url: url,
        data: { selectedUrl: url },
        method: 'GET',
        success: function (response) {
            let cleanURL = url.split("?")[1];
            let baseURL = window.location.href.split("?")[0] + "?";
            let finalURL = baseURL + urlUtils.getSearchParamsWithExcludedFilters(cleanURL);
            history.pushState({}, "", finalURL);
            $('.product-grid').empty().html(response);
            wishlistHeart.isInWishlist();

            if (shouldUpdateSortOptions) {
                var $selectedOption = $(response).find('[name=sort-order] option:selected');
                $('.js-mobile-sort').removeClass('selected');
                $('.js-mobile-sort[data-id=' + $selectedOption.attr('data-id') + ']').addClass('selected');
                $('.js-selected-sort-option').text($selectedOption.text());
            }

            initObserver("js-observer-tile");

            window.dispatchEvent(new CustomEvent("refinementUpdate"), {});

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Close mobile filter modal
 */
function closeFilterModal() {
    var $modal = $('.js-refinement-modal').not('.mobile-hidden');
    $modal.addClass('mobile-hidden');
    $modal.siblings().attr('aria-hidden', false);
    $modal.closest('.row').siblings().attr('aria-hidden', false);
    $modal.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    $modal.closest('.container.search-results').siblings().attr('aria-hidden', false);
    $($modal.attr('data-trigger')).focus();
    $('body').removeClass('no-scroll');
    $('.js-filters-modal-background').hide();

    // Reset selected availability filters filters on modal close
    if ($modal.hasClass('filters-mobile-store')) {
        var selectedFilters = [];

        $('.applied-filters button').each(function () {
            selectedFilters.push($(this).attr('data-value'));
        });

        $modal.find('.refinement-item button').each(function () {
            $(this).toggleClass('selected', selectedFilters.indexOf($(this).attr('data-value')) > -1);
        });
    }
}

/**
 * Format price range inputs
 */
function initPriceFormatter() {
    var Cleave = require('cleave.js').default;
    var $priceField = $(".js-price-selection-input");

    if ($priceField.length) {
        $priceField.each(function () {
            var self = $(this);
            var cleave = new Cleave(self, {
                numeral: true,
                delimiter: '',
                blocks: ''
            });

            self.data('cleave', cleave);
        });
    }
}

/**
 * Handles mobile refinement functionality
 * @param {string} refinementClass - class name of the refinement container
 * @param {jQuery} $this - jQuery object representing the current element
 * @returns {void}
 */
function handleMobileRefinement(refinementClass, $this) {
    var $refinementContainer = $(".active-desktop");
    var refinementHeight = $refinementContainer.find(".card-header").height();

    if (window.innerWidth < 922) {
        if ($refinementContainer.hasClass("active")) {
            $refinementContainer.removeClass("active").height(refinementHeight);
            $refinementContainer.attr("aria-expanded", false);
        }

        if (refinementClass && $this) {
            if (!$this.hasClass("selected")) {
                $(refinementClass).addClass("active").height("auto");
                $(refinementClass).attr("aria-expanded", true);
            }
        }
    } else {
        if (!$refinementContainer.hasClass("active")) {
            $refinementContainer.addClass("active");
            $refinementContainer.attr("aria-expanded", true);
        }
    }
}

/**
 * Loads content asynchronously and updates the DOM
 */
function loadTileContent() {
    var lazyTiles = $(".js-lazy-tile");
    $(".js-observer-tile").removeClass("js-observer-tile");

    if (lazyTiles.length > 6) {
        lazyTiles.splice(6);
    }

    $.each(lazyTiles, function (indexInArray, tile) {
        var tileImages = $(tile).find("[data-lazy-src]");
        $.each(tileImages, function (imgIndex, image) {
            $(image).attr("src", $(image).data("lazy-src"));
        });
        $(tile).removeClass("js-lazy-tile");
        if (indexInArray === 2) { // Changed indexInArray from 3 to 2
            if (!$(tile).hasClass("js-last-tile")) {
                $(tile).addClass("js-observer-tile");
                initObserver("js-observer-tile");
            }
        }
    });
}

const debouncedLoadTileContent = debounce(loadTileContent, 1);


/**
 * Initializes an IntersectionObserver to lazy load content when elements come into view
 * @param {string} elementClass - the class name of the elements to observe
 * @returns {void}
 */
function initObserver(elementClass) {
    const slotObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                if ($(entry.target).hasClass("js-observer-tile")) {
                    debouncedLoadTileContent();
                } else {
                    $(entry.target).find("[data-lazy-src]").each(function () {
                        $(this).attr("src", $(this).data("lazy-src"));
                    });
                }
            }
        });
    });

    const observerTiles = $("." + elementClass);

    if (observerTiles && observerTiles.length > 0) {
        $.each(observerTiles, function (indexInArray, observerTile) {
            slotObserver.observe(observerTile);
        });
    }
}

module.exports = {
    /**
     * Function to handle the display of refinements bar when Menu icon is clicked
     */
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.js-filter-results', function () {
            var $contentToShow = $('.' + $(this).attr('data-target'));

            $contentToShow.removeClass('mobile-hidden');
            $contentToShow.siblings().attr('aria-hidden', true);
            $contentToShow.closest('.row').siblings().attr('aria-hidden', true);
            $contentToShow.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $contentToShow.closest('.container.search-results').siblings().attr('aria-hidden', true);
            $contentToShow.find('.close').focus();
            $('.js-back-to-top').removeClass('show');

            if (!$('body').find('.js-filters-modal-background').length) {
                var backgroundHTML = '<div class="filters-modal-background js-filters-modal-background"></div>';
                $('body').append(backgroundHTML);
            }
            $('header').removeClass("header-above");
            $('body').addClass('no-scroll');
            $('.js-filters-modal-background').show();
        });
        handleMobileRefinement();
        initObserver("js-observer-tile");

        $(window).on("resize", function () {
            handleMobileRefinement();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(document).on('click', '.js-close-refinements, .js-filters-mobile-apply, .js-filters-modal-background', function () {
            closeFilterModal();
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            sortResults(this.value, false);
            initObserver("js-observer-tile");
        });

        $('.container').on('click', '.js-mobile-sort', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            sortResults($(this).attr('data-href'), true);
            initObserver("js-observer-tile");
            setTimeout(() => {
                sortUtils.closeDropdown();
            });
        });
       
        $(document).on('click', '.js-dropbtn', function (e) {
            sortUtils.handleDropdownClick(e, $(this));
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.js-dropdown-menu').length) {
                sortUtils.closeDropdown();
            }
        });

        $(window).on('touchmove', function () {
            sortUtils.closeDropdown();
        });
    },

    showMore: function () {
        $('.container').on('change', '.items-per-page-select', function (e) {
            var showMoreUrl = $(this).find(':selected').data('url');
            var sortOrder = $('#sort-order').find(":selected");
            if (sortOrder && sortOrder.length) {
                var sortOrderValue = sortOrder[0].className;
                showMoreUrl = urlUtils.updateURLWithParam(showMoreUrl, "srule", sortOrderValue);
            }
            getProduct(e, showMoreUrl, 'items-per-page-select', null, true, null);
        });

        $(document).on('click', '.js-pagination-arrow', function (e) {
            var showMoreUrl = $(this).data('url');
            var showLessUrl = $(this).data('show-less-url');
            var prevArrow = $(this).hasClass('prev');
            $(".js-seo-pagination-data").remove();
            getProduct(e, showMoreUrl, 'product-arrow-left-pagination', prevArrow, null, showLessUrl);
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button:not(.js-select-store), .js-store-refinements-apply, button.reset, .filter-value button, .swatch-filter button, .js-price-selection-button, .js-price-selection-clear, .js-store-refinement-link, .js-refinement-value-button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this);
                $this.trigger('search:filter', e);
                var attributeId = '#' + $this.find('span').last().attr('id');
                var refinementClass = ".js-" + $($this).parents(".refinement").attr("data-refinement-id");
                var isCustomPriceRefinement = $this.hasClass('js-price-selection-button');
                var isAvailabilityMobile = $this.hasClass('js-store-refinements-apply');

                var $selectorContainer = $('#price-selection-form');
                var $priceInputButton = $selectorContainer.find('.js-price-selection-button');
                var url = $('.js-price-refinement').not('.selected').attr('data-href') ? $('.js-price-refinement').not('.selected').attr('data-href') : window.location.href;

                var urlParams = new URLSearchParams(url.split('?')[1]);

                // Get price parameters
                var pmin = parseInt($selectorContainer.find('[name="inputPriceMin"]').val(), 10);
                var pmax = parseInt($selectorContainer.find('[name="inputPriceMax"]').val(), 10);
                if (pmax !== 0 && pmax > pmin) {
                    urlParams.set('pmin', pmin);
                    urlParams.set('pmax', pmax);

                    // Update the price selection input button href
                    $priceInputButton.attr('data-href', url.split('?')[0] + '?' + urlParams.toString());
                }


                var sortOrder = $('#sort-order').find(":selected");

                $.spinner().start();

                let href = $this.attr('data-href') ? $this.attr('data-href') : window.location.href;

                if ($this.hasClass("js-view-all")) {
                    let $pickupEl = $('.js-pick-up');
                    href = $pickupEl && $pickupEl.length > 0 ? $pickupEl.attr('data-href') : href;
                    let viewAllURLParams = new URLSearchParams(href.split('?')[1]);
                    let deliveryTypeValueKey;
                    let deliveryTypeNameKey;

                    viewAllURLParams.values().forEach(function (value, key) {
                        if (value && (value == "deliveryType" || value =="eligibilityType")) {
                            deliveryTypeValueKey = key + 1;
                        }
                    });

                    viewAllURLParams.keys().forEach(function (value, key) {
                        if (key) {
                            if (key == deliveryTypeValueKey) {
                                deliveryTypeNameKey = value;
                            }
                        }
                    });

                    if (deliveryTypeNameKey) {
                        viewAllURLParams.set(deliveryTypeNameKey, "");
                    }

                    viewAllURLParams.delete("deliveryType");
                    viewAllURLParams.delete("eligibilityType");

                    href = href.split('?')[0] + '?' + viewAllURLParams.toString();
                }

                var hrefUrlParams = new URLSearchParams(href.split('?')[1]);
                var storeRefinementNumber = urlUtils.getStoreRefinementNumber(hrefUrlParams);
                if (storeRefinementNumber) {
                    hrefUrlParams.delete("prefn" + storeRefinementNumber);
                    hrefUrlParams.delete("prefv" + storeRefinementNumber);
                    href = href.split('?')[0] + '?' + hrefUrlParams.toString();
                }
                if (sortOrder && sortOrder.length) {
                    var sortOrderValue = sortOrder[0].className;
                    href = urlUtils.updateURLWithParam(href, "srule", sortOrderValue);
                }

                var sz = $('#items-per-page-cont-selected').find(":selected");
                var szValue;

                if (sz && sz.length) {
                    szValue = sz[0].value;
                    href = urlUtils.updateURLWithParam(href, "sz", szValue);
                } else {
                    var actualParams = window.location.href.split("?")[1];

                    if (actualParams && actualParams.length > 0) {
                        var paramValueArray = actualParams.split("&");

                        paramValueArray.forEach(function (paramValue) {
                            if (paramValue && paramValue.split("=").length > 1) {
                                var actualParam = paramValue.split("=")[0];

                                if (actualParam == "sz") {
                                    szValue = paramValue.split("=")[1];
                                    href = urlUtils.updateURLWithParam(href, "sz", szValue);
                                }
                            }
                        });
                    }
                }

                if ($this.parents("#refinement-exclude-oos") && $this.parents("#refinement-exclude-oos").length === 0) {
                    href = includeOOSSelectionToUrl(href);
                }

                $.ajax({
                    url: href,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: href
                    },
                    method: 'GET',
                    success: function (response) {
                        let actualURL = window.location.href.split("?")[0];
                        let newAttr = href.split("?")[1];
                        let isIndexableFacet = $this.data('is-indexable-facet');
                        let isResetButton = $this.hasClass("js-reset-filters");
                        let isRemoveFilter = $this.hasClass("js-remove-filter");
                        let changeFacetMetadata = isIndexableFacet || isResetButton || isRemoveFilter;
                        let newURL = isIndexableFacet && $this.data('state-url') ? $this.data('state-url') : actualURL + "?" + newAttr;

                        if (isResetButton) {
                            const hasIndexableFacetSelected = $('.js-remove-filter[data-is-indexable-facet]').length > 0;
                            if (hasIndexableFacetSelected) {
                                const resetLink = $('.permalink', response).val();
                                newURL = resetLink || newURL;
                            }
                        }

                        var searchParams = new URLSearchParams(window.location.search);
                        var ppcValue = searchParams.get("ppc");

                        if (ppcValue) {
                            newURL = newURL + "&ppc=" + ppcValue;
                        }

                        parseResults(response, isCustomPriceRefinement, changeFacetMetadata);

                        if (changeFacetMetadata && $(".js-is-category-search").val() === "true") {
                            parseHeadElements(response);
                        }

                        wishlistHeart.isInWishlist();

                        if (attributeId) {
                            $(attributeId).parent('button').focus();
                        }
                        if (isCustomPriceRefinement) {
                            $(document).find('.js-price-selection-clear').removeClass('disabled');
                        }

                        mirrorHeaderStoreFilter(true);

                        if (isAvailabilityMobile) {
                            closeFilterModal();
                        }

                        handleMobileRefinement(refinementClass, $this);
                        initPriceFormatter();
                        initObserver("js-observer-tile");
                        window.dispatchEvent(new CustomEvent("refinementUpdate"), {});
                        window.history.pushState({}, "", newURL);
                        if ($(e.target).is('button.reset')) {
                            sortUtils.resetCollapsibleSections();
                        }
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    }
                });
            });
    },

    showContentTab: function () {
        $('.container').on('click', '.content-arrow-left-pagination', function (e) {
            getContent(e, $(this), 'content-arrow-left-pagination');
        });

        $('.container').on('click', '.content-arrow-right-pagination', function (e) {
            getContent(e, $(this), 'content-arrow-right-pagination');
        });
    },

    // Custom price refinement logic - uses the values in input to apply custom pricing range
    initCustomPriceRefinement: function () {
        initPriceFormatter();

        $(document).on('keyup', '.js-price-selection-input', function () {
            // Return if invalid
            if (!$(this)[0].validity.valid) {
                $(this).val($(this).val().replace(/\D/g, ''));
            }

            var $selectorContainer = $(this).parents('.price-selection');
            var $applyButton = $selectorContainer.find('.js-price-selection-button');
            var url = $('.js-price-refinement').not('.selected').attr('data-href') ? $('.js-price-refinement').not('.selected').attr('data-href') : window.location.href;

            var urlParams = new URLSearchParams(url.split('?')[1]);

            // Get new price parameters
            var pmin = parseInt($selectorContainer.find('[name="inputPriceMin"]').val(), 10);
            var pmax = parseInt($selectorContainer.find('[name="inputPriceMax"]').val(), 10);

            // Disable button is range is not valid
            var buttonIsValid = pmax !== 0 && pmax > pmin;
            $applyButton.attr('disabled', !buttonIsValid);

            if (buttonIsValid) {
                urlParams.set('pmin', pmin);
                urlParams.set('pmax', pmax);

                // Update the apply button href
                $applyButton.attr('data-href', url.split('?')[0] + '?' + urlParams.toString());
            } else {
                return;
            }
        });
    },

    initCustomStoreRefinement: function () {
        mirrorHeaderStoreFilter(true);

        $(document).on('storeFilterSelected', function () {
            selectHiddenStoreParams();
        });

        $(window).on("resize orientationchange", debounce(function () {
            if (window.matchMedia("(min-width: 992px)").matches && !$(".minicart").hasClass("active")) {
                $('.js-filters-modal-background').removeAttr('style');
                $('body').removeClass('no-scroll');

                // Reinit collapsible state
                var $collapsibleItems = $('.refinements').find('.collapsible-transition');

                $collapsibleItems.each(function () {
                    collapsibleItem.methods.setTransitionState($(this), true);
                });
            }
        }, 500));

        // Mobile availability filter - gather applied filters data and apply on click
        $(document).on('click', '.filters-mobile-store li button:not(.js-select-store)', function (e) {
            e.preventDefault();

            // Check the filter box
            $(this).toggleClass('selected');

            var $applyButton = $(document).find('.js-store-refinements-apply');
            var url = $(document).find('.js-base-url').attr('data-href');

            // Get initial URL params
            var urlParams = new URLSearchParams(url.split('?')[1]);

            // Get the prefNum for deliveryType
            var prefNum = null;

            for (const [key, value] of urlParams.entries()) {
                if (`${value}` == 'deliveryType') {
                    prefNum = key.replace("prefn", "");
                }
            }

            var $selectedAvailabilityOptions = $('.filters-mobile-store li button.selected');
            var values = [];

            // Collect all selected values for the deliveryType attribute
            $selectedAvailabilityOptions.each(function () {
                values.push($(this).attr('data-value'));
            });

            // Update urlParams with all the selected values
            if (!isNaN(prefNum) && prefNum !== null) {
                urlParams.set(`prefv${prefNum}`, values.join('|'));
            }

            // Update the apply button href
            $applyButton.attr('data-href', url.split('?')[0] + '?' + urlParams.toString());
        });
    },

    initBackToTopButton: function () {
        var $backToTop = $('.js-back-to-top');
        var lastScrollY = window.pageYOffset;
        var scrollTimeout;

        if ($backToTop.length > 0) {
            $(window).on('scroll', function () {
                var currentScrollY = window.pageYOffset;
                var isScrollingUp = currentScrollY < lastScrollY;

                lastScrollY = currentScrollY;

                if (!isScrollingUp) {
                    $backToTop.removeClass('show');
                } else if (currentScrollY > 0) {
                    $backToTop.addClass('show');
                }

                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(function () {
                    if (isScrollingUp && currentScrollY > 0) {
                        $backToTop.addClass('show');
                    } else {
                        $backToTop.removeClass('show');
                    }
                }, 150);
            });

            $(document).on('click', '.js-back-to-top', function (e) {
                e.preventDefault();
                $('html, body').animate({ scrollTop: 0 }, 300);
            });
        }
    },

    /**
     * Initializes the refinements for the page
     * @function initRefinements
     * @memberof Namespace
     * @returns {void}
     */
    initRefinements: function () {
        $(document).ready(function () {
            handleMobileRefinement();
            initObserver("js-observer-tile");
            initObserver("js-lazy-tile");
        });
    },

    scrollToTile: function () {
        $(window).on("load", function () {
            var urlParams = new URLSearchParams(window.location.search);
            var tileId = urlParams.get("tileId");

            if (tileId) {
                var targetId = "tile-" + tileId;
                var offset = -100;
                var $firstTile = $(".product-tile").first();
                var $imageContainer = $firstTile.find(".image-container");
                var imgHeight = $imageContainer.outerHeight();

                if (imgHeight) {
                    $(".product-tile .image-container").css("min-height", imgHeight + "px");
                }

                setTimeout(function () {
                    var $el = $("#" + targetId);

                    if ($el.length) {
                        var y = $el.offset().top + offset;
                        $(window).scrollTop(y);
                    }
                }, 2000);
            }
        });
    }
};
